"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cellclass = void 0;
const _ = __importStar(require("lodash"));
const helpers_1 = require("../helpers");
function cellclass(opts) {
    if (!opts) {
        throw new TypeError('Options is required.');
    }
    const options = opts.options, className = opts.className;
    const valueResolver = opts.value;
    const cellclassFormatter = (row, cell, value, columnDef, data) => {
        if (value == null)
            return '';
        if (valueResolver) {
            let cls_values = [];
            let values = valueResolver(data);
            if (_.isString(values)) {
                cls_values.push(values);
            }
            else if (_.isObject(values)) {
                _.chain(values)
                    .each((v, k) => {
                    if (v && k) {
                        cls_values.push(k);
                    }
                })
                    .value();
            }
            if (cls_values.length) {
                return {
                    text: value,
                    addClasses: cls_values.join(' ')
                };
            }
        }
        if (options) {
            const field = columnDef.field;
            (0, helpers_1.assertNonNullish)(field, 'ColumnDefinition.field must have a value.');
            let cls = options[opts.optionsSource === 'fieldValue' ? data[_.toString(field)] : value];
            if (cls) {
                return {
                    text: value,
                    addClasses: cls + (className ? ` ${className}` : '')
                };
            }
        }
        return value;
    };
    cellclassFormatter.exportRawData = true;
    return cellclassFormatter;
}
exports.cellclass = cellclass;
//# sourceMappingURL=cellclass.js.map